/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoConnectionBold/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NoConnectionBold({
  children,
  viewPath = "/DesignSystem/Svgs/NoConnectionBold",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 100,
  height = 100,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#ED3701"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="NoConnectionBold.Svg"
  data-view-path={viewPath}
 viewBox="0 0 100 100"
 overflow="visible"
 style={{'--as-1-Z1fSXkb': alignSelf,'--mt-2-Z1fSXkb': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1fSXkb': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1fSXkb': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1fSXkb': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1fSXkb': opacity,'--w-10-Z1fSXkb': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1fSXkb': typeof height === 'number' ? `${height}px` : height,'--a-7-Z1fSXkb': isAnimated ? animation : "none",'--sd-8-Z1fSXkb': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1fSXkb': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<circle
  data-testid="NoConnectionBold.SvgCircle"
  data-view-path={viewPath}
 cx={50}
 cy={81.2}
 r={6.8}
 style={{'--f-12-Z1fSXkb': fill}}
 className={`views-block ${styles.SvgCircle}`}
/>
<path
  data-testid="NoConnectionBold.SvgPath"
  data-view-path={viewPath}
 d="M58.6 69.7c-2.3-2.3-5.4-3.6-8.6-3.6s-6.3 1.3-8.6 3.6l-7.1-7.1c4.2-4.2 9.8-6.5 15.7-6.5 5.9 0 11.5 2.3 15.7 6.5l-7.1 7.1z"
 style={{'--f-12-Z1fSXkb': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="NoConnectionBold.SvgPath:1"
  data-view-path={viewPath}
 d="M6.446 86.492L86.42 6.508l7.072 7.07-79.973 79.985z"
 style={{'--f-12-Z1fSXkb': fill}}
 className={`views-block ${styles.SvgPath1}`}
/>
<path
  data-testid="NoConnectionBold.SvgPath:2"
  data-view-path={viewPath}
 d="M73.4 55c-4.4-4.4-9.9-7.4-15.8-8.8l2.3-9.7c7.8 1.8 15 5.8 20.6 11.5l-7.1 7zM88.1 40.3c-4.5-4.5-9.7-8.2-15.5-10.8l4.2-9.1c6.8 3.2 13 7.5 18.3 12.8l-7 7.1zM26.6 55l-7-7c8.3-8.3 19.4-12.8 31.2-12.6 0 0-7.7 7.6-12.1 12-4.5 1.5-8.6 4.2-12.1 7.6zM11.9 40.3l-7.1-7.1C21.7 16.4 46 10.4 68.7 17.3l-8.2 8.2C42.9 22 24.8 27.4 11.9 40.3z"
 style={{'--f-12-Z1fSXkb': fill}}
 className={`views-block ${styles.SvgPath2}`}
/>
</svg>
{children}
</React.Fragment>)
}